import { Logger } from "neo-common";

export class Controller extends PIXI.utils.EventEmitter {
    protected log(s: string): void {
        if (DEBUG) {
            const compName = (this as any).__componentName__;

            Logger.debugGroup(compName, s);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Controller.ts
 **/